// extracted by mini-css-extract-plugin
module.exports = {"container":"_1H6Ydrt0nygFD0uZoo_CFM"};